import { createTheme } from '@clds/component-theme';

export const sliderTheme = createTheme({
  normal: {
    height: '1rem',
    track: {
      height: '0.25rem',
    },
    handler: {
      border: {
        radius: '100px',
      },
      width: '1rem',
      height: '1rem',
    },
  },
  trim: {
    track: {
      height: '1rem',
    },
    handler: {
      border: {
        radius: '15px',
      },
      width: '1.25rem',
      height: '1.25rem',
    },
  },
});
